<template>
  <Header />
  <router-view />
  <Overlay v-if="isOverlayShown" />
  <Footer />
</template>

<script>
import Header from '@/components/pollock/header/Header.vue'
import Overlay from './components/pollock/Overlay.vue'
import Footer from './components/pollock/Footer.vue'
import { mapState } from 'vuex'
import { store } from '@/main'
import { walletEventSetup } from '@/store/wallet'



export default {
  components: {
    Header,
    Overlay,
    Footer
  },
  data() {
    return {
      walletCleanup: null
    }
  },
  computed: {
    ...mapState({
      isOverlayShown: state => state.ui.isOverlayShown
    })
  },
  created() {
    document.addEventListener('SWUpdated', this.showRefresh)
  },
  mounted() {
    const { cleanup } = walletEventSetup(store)
    this.walletCleanup = cleanup
  },
  beforeUnmount() {
    if (this.walletCleanup) {
      this.walletCleanup()
      this.walletCleanup = null
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/pollock-main';
</style>
